/**
 * Chilli UI styling
 */
import './src/assets/styles/global.scss';

/**
 * Google fonts
 * Installed locally to speed up serving
 */
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

// Additional polyfils
import './src/app/broadcastChannels/polyfil';

// Redux wrapper component.
import wrapWithProvider from './src/app/redux/wrapWithProvider';

// Used to configure the redux store and add root toaster element
export const wrapRootElement = wrapWithProvider;

//  utilities
import browserHydrateFunction from './src/app/utils/gatsby/browser-hydrate-function';

export const replaceHydrateFunction = browserHydrateFunction;
